import { render } from "./AccessView.vue?vue&type=template&id=0789f061"
const script = {}

import exportComponent from "D:\\ZAHB\\live-sdk-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__